'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.track = track;

var _utils = require('./utils');

var _navigator = require('./lib/navigator');

var _env = require('./lib/env');

var IS_TRACKING = '__isTrackingBiBrowsingSession__';
var ENDPOINT = 'p';
var SOURCE = 19;
var EVID = 3;

function shouldTrack() {
  return !(0, _env.isWebWorker)() && (0, _env.provideBrowsingContext)(function (window) {
    return !window[IS_TRACKING];
  });
}

function setIsTracking() {
  return (0, _env.provideBrowsingContext)(function (window) {
    return window[IS_TRACKING] = true;
  });
}

function getLogger(loggerFactory) {
  return loggerFactory({ endpoint: ENDPOINT, useBeacon: true }).setDefaults({ src: SOURCE, evid: EVID, vsi: (0, _utils.guid)() }).logger();
}

/**
 * Sends a page view event on initial load and on every page switch
 */
function track(loggerFactory) {
  if (shouldTrack()) {
    setIsTracking();

    var logger = getLogger(loggerFactory);
    (0, _navigator.listen)(function (fromUrl, toUrl) {
      return logger.log({ from: fromUrl, to: toUrl });
    });
  }
}
//# sourceMappingURL=browsingSession.js.map



//////////////////
// WEBPACK FOOTER
// ./~/web-bi-logger/dist/src/browsingSession.js
// module id = 1122
// module chunks = 15 16 17 18 19